import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.keys.js";
import api from '@/api';
export default {
  name: 'AgencyInfo',
  data: function data() {
    return {
      rules: {
        passWord: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }],
        rePassWord: [{
          required: true,
          message: '请输入确认密码',
          trigger: 'blur'
        }]
      },
      form: {
        passWord: null,
        rePassWord: null
      },
      downUrl: process.env.VUE_APP_DOWNLOAD_URL,
      agencyInfo: {
        image: '',
        promotionCode: '',
        citysStr: null
      },
      dialogVisible: false,
      matchmakerSexSts: null,
      manNum: 0,
      nvNum: 0,
      cashbackNum: 0,
      rechargeNum: 0,
      todyManNum: 0,
      todyNvNum: 0,
      todyCashbackNum: 0,
      todyRechargeNum: 0,
      agencyMemberSettlementItemEnums: []
    };
  },
  methods: {
    itemCityName: function itemCityName(item) {
      var name = '';
      for (var i in item) {
        name = item[i];
      }
      return name;
    },
    updatePassWord: function updatePassWord() {
      var _this = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this.$confirm('此操作将永久修改该数据, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            _this.updatePassWordApi();
          }).catch(function () {
            _this.$message({
              type: 'info',
              message: '已取消修改'
            });
          });
        }
      });
    },
    updatePassWordApi: function updatePassWordApi() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var user;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              user = JSON.parse(localStorage.getItem('userInfo'));
              _this2.form.agencyId = user.id;
              _context.n = 1;
              return api.UPDATE_PASSWORD(_this2.form);
            case 1:
              _this2.$message.success('修改成功');
              _this2.dialogVisible = false;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    checkSettlementItemKey: function checkSettlementItemKey(key) {
      return this.enums.checkEnumsValue(this.agencyMemberSettlementItemEnums, key, '-');
    },
    getAgencyMemberSettlementItemEnums: function getAgencyMemberSettlementItemEnums() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return api.GET_ENUMERATION_LIST({
                name: 'agency_settlement_items'
              });
            case 1:
              res = _context2.v;
              _this3.agencyMemberSettlementItemEnums = res.body;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    showUpdatePassWord: function showUpdatePassWord() {
      this.form.rePassWord = null;
      this.form.passWord = null;
      this.dialogVisible = true;
    },
    agencyInfoApi: function agencyInfoApi() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var userInfo, par, res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              userInfo = JSON.parse(localStorage.getItem('userInfo'));
              par = {
                agencyId: userInfo.id
              };
              _context3.n = 1;
              return api.GET_AGENCYMEMBER_INFO(par);
            case 1:
              res = _context3.v;
              _this4.agencyInfo = res.body;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    getAgencySexStsApi: function getAgencySexStsApi() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var par, res, item, item1, item2;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              par = {};
              _context4.n = 1;
              return api.GET_AGENCY_SEX_STS(par);
            case 1:
              res = _context4.v;
              _this5.matchmakerSexSts = res.body;
              if (_this5.matchmakerSexSts.cashbackNum !== null) {
                _this5.cashbackNum = _this5.matchmakerSexSts.cashbackNum;
              }
              if (_this5.matchmakerSexSts.rechargeNum !== null) {
                _this5.rechargeNum = _this5.matchmakerSexSts.rechargeNum;
              }
              if (_this5.matchmakerSexSts.memberSexSumCounts.length > 0) {
                if (_this5.matchmakerSexSts.memberSexSumCounts.length === 1) {
                  item = _this5.matchmakerSexSts.memberSexSumCounts[0];
                  if (item.sex === '男') {
                    _this5.manNum = item.num;
                  } else {
                    _this5.nvNum = item.num;
                  }
                } else {
                  item1 = _this5.matchmakerSexSts.memberSexSumCounts[0];
                  item2 = _this5.matchmakerSexSts.memberSexSumCounts[1];
                  _this5.manNum = item1.num;
                  _this5.nvNum = item2.num;
                }
              }
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    getAgencySexStsYYmmDDApi: function getAgencySexStsYYmmDDApi() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var par, res, item, item1, item2;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              par = {
                createTime: 'tody'
              };
              _context5.n = 1;
              return api.GET_AGENCY_SEX_STS(par);
            case 1:
              res = _context5.v;
              _this6.matchmakerSexSts = res.body;
              if (_this6.matchmakerSexSts.cashbackNum !== null) {
                _this6.todyCashbackNum = _this6.matchmakerSexSts.cashbackNum;
              }
              if (_this6.matchmakerSexSts.rechargeNum !== null) {
                _this6.todyRechargeNum = _this6.matchmakerSexSts.rechargeNum;
              }
              if (_this6.matchmakerSexSts.memberSexCounts.length > 0) {
                if (_this6.matchmakerSexSts.memberSexCounts.length === 1) {
                  item = _this6.matchmakerSexSts.memberSexCounts[0];
                  if (item.sex === '男') {
                    _this6.todyManNum = item.num;
                  } else {
                    _this6.todyNvNum = item.num;
                  }
                } else {
                  item1 = _this6.matchmakerSexSts.memberSexCounts[0];
                  item2 = _this6.matchmakerSexSts.memberSexCounts[1];
                  _this6.todyManNum = item1.num;
                  _this6.todyNvNum = item2.num;
                }
              }
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    }
  },
  created: function created() {
    this.getAgencyMemberSettlementItemEnums();
    this.getAgencySexStsYYmmDDApi();
    this.getAgencySexStsApi();
    this.agencyInfoApi();
  }
};